import loggingDevInfo from '@/services/log-dev-info';

export const getWebshopData = (product, country) => {
	// merges webshopData into product data root
	if (!product) return;
	let prod = product;
	const {webshopData} = prod;

	const wbData = webshopData[country] ? webshopData[country] : webshopData.default ? webshopData.default : null;
	if (!wbData) loggingDevInfo('Webshop Data missing');
	// remove this line when clearing the filters
	if (wbData.filterCategories) delete wbData.filterCategories;
	//
	if (webshopData) prod = {...prod, ...wbData};
	return prod;
};
